import React from "react";
import GetTransformedDate from "../../../../../../utils/dateViewTransformer.tsx";
import { useContent } from "../../../../../../contexts/contentContext/contentContext.js";

const SelectedDatesHeader = ({
  allTime,
  customDays,
  selectedStartDate,
  selectedEndDate,
  setDisplayDatepicker,
  setSelectedStartDate,
  setSelectedEndDate,
  setChangeStartDate,
  setChangeEndDate,
  setStartDate,
  setEndDate,
  setCustomDays,
  setAllTime
}) => {
  const { getTextByKey, getDirection } = useContent();
  const returnDayOfMonth = (date) => {
    const converterdDate = new Date(date);
    return converterdDate.getDate();
  };

  const returnDate = (date) => {
    return (
      <GetTransformedDate
        date={date}
        fullView={true}
        showDay={false}
        showTime={false}
        shortNames={true}
      />
    );
  };

  return (
    <div className="selected-dates">
      <div
        className={getDirection() === "rtl" ? "exit-rtl" : "exit"}
        onClick={() => {
          setDisplayDatepicker(false);
          setStartDate(null);
          setEndDate(null);
          setSelectedStartDate(null);
          setSelectedEndDate(null);
          setCustomDays(false);
          setAllTime(false);
        }}
      >
        <i className="fas fa-times"></i>
      </div>
      {!allTime ? (
        !customDays ? (
          selectedStartDate &&
          selectedEndDate &&
          selectedStartDate.date < selectedEndDate.date ? (
            <>
              <span className="blue">
                {returnDayOfMonth(selectedStartDate.date)}{" "}
                {returnDate(selectedStartDate.date)}
              </span>
              <span className="blue">{" - "}</span>
              <span className="blue">
                {returnDayOfMonth(selectedEndDate.date)}{" "}
                {returnDate(selectedEndDate.date)}
              </span>
            </>
          ) : selectedStartDate ? (
            <span className="blue">
              {returnDayOfMonth(selectedStartDate.date)}{" "}
              {returnDate(selectedStartDate.date)}
            </span>
          ) : (
            <span className="blue">
              {getTextByKey("datepicker-select-date")}
            </span>
          )
        ) : !selectedStartDate && !selectedEndDate ? (
          <span className="green">
            {getTextByKey("datepicker-select-start-date")}
          </span>
        ) : selectedStartDate && !selectedEndDate ? (
          <>
            <span
              className="blue"
              onClick={() => {
                setSelectedStartDate(null);
                setChangeStartDate((prev) => !prev);
                setChangeEndDate(false);
              }}
            >
              {returnDayOfMonth(selectedStartDate.date)}{" "}
              {returnDate(selectedStartDate.date)}
            </span>
            {" - "}
            <span className="green">
              {getTextByKey("datepicker-select-end-date")}
            </span>
          </>
        ) : !selectedStartDate && selectedEndDate ? (
          <>
            <span className="green">
              {getTextByKey("datepicker-select-start-date")}
            </span>
            {" - "}
            <span
              className="blue"
              onClick={() => {
                setSelectedStartDate(null);
                setChangeStartDate((prev) => !prev);
                setChangeEndDate(false);
              }}
            >
              {returnDayOfMonth(selectedEndDate.date)}{" "}
              {returnDate(selectedEndDate.date)}
            </span>
          </>
        ) : (
          <>
            <span
              className="blue"
              onClick={() => {
                setSelectedStartDate(null);
                setChangeStartDate((prev) => !prev);
                setChangeEndDate(false);
              }}
            >
              {returnDayOfMonth(selectedStartDate.date)}{" "}
              {returnDate(selectedStartDate.date)}
            </span>
            <span className="blue">{" - "}</span>
            <span
              className="blue"
              onClick={() => {
                setSelectedEndDate(null);
                setChangeEndDate((prev) => !prev);
                setChangeStartDate(false);
              }}
            >
              {returnDayOfMonth(selectedEndDate.date)}{" "}
              {returnDate(selectedEndDate.date)}
            </span>
          </>
        )
      ) : (
        <span className="blue">{getTextByKey("datepicker-all-time")}</span>
      )}
    </div>
  );
};

export default SelectedDatesHeader;
